export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7057.1aaad20a.jpg";